import axios from 'axios';

export const getEventById = async (id) => {
  const response = await axios.get(`/plans/${id}`);

  return response;
};

export const getEventSeatMap = (id) => axios.get(`/plans/${id}/seat-map`);

export const getEventByIdAdmin = async (id) => {
  const response = await axios.get(`/plans/admin/${id}`);

  return response;
};

export const updateEventByIdAdmin = (eventId, data) => axios.put(`/plans/admin/${eventId}`, data);
export const getEventReport = (eventId) => axios.get(`/plans/admin/${eventId}/report`);
export const saveSeatPlan = (eventId, seatPlan) => axios.put(`/plans/admin/${eventId}/seat-plan`, { seatPlan });

export const getEvents = async (config) => {
  const response = await axios.get('plans', config);

  return response;
};

export const createEvent = (data) => axios.post('/plans/admin', data);

export const uploadEventPhoto = (eventId, file) => {
  const formData = new FormData();
  formData.append('photo', file);
  return axios.post(`/plans/admin/${eventId}/photo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const uploadGalleryPhoto = (eventId, file) => {
  const formData = new FormData();
  formData.append('photo', file);
  return axios.post(`/plans/admin/${eventId}/gallery`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteGalleryPhoto = (eventId, photoUrl) =>
  axios.delete(`/plans/admin/${eventId}/gallery`, { data: { photoUrl } });
